const UPSELL_SECTION_HANDLE = 'upsell-products';
const UPSELL_LIMIT = document.querySelector('.upsells_data')?.getAttribute('upsell_limit') || 4;
const MATCH_BY = document.querySelector('.upsells_data')?.getAttribute('matched_type') || 'vendor'; 

async function getCartData() {
  const res = await fetch('/cart.js');
  return res.json();
}

// progress bar js

const progressEl = document.querySelector('.get_from_here');

if (progressEl) {
  const beforeMsg = progressEl.getAttribute('data-before');
  const afterParts = progressEl.getAttribute('data-after').split('-');
  const fullMsg = progressEl.getAttribute('data-full');

  function updateProgressBar(cartTotal) {
    const goal = window.freeShippingGoal;

    const text = document.querySelector('.progress-text');
    const fill = document.querySelector('.progress-fill');
    const bar = document.querySelector('.progress-bar');

    const percentage = Math.min((cartTotal / goal) * 100, 100);
    if (fill) fill.style.width = `${percentage}%`;

    if (!text) return;

    if (cartTotal >= goal) {
      text.textContent = fullMsg;
      bar.classList.add('completed');
    } else {
      const remaining = ((goal - cartTotal) / 100).toFixed(2);

      text.innerHTML = `
        ${beforeMsg} <strong>€${remaining}</strong> 
        ${afterParts[0]} ${afterParts[1] || ''}
      `;

      bar.classList.remove('completed');
    }
  }


  function fetchAndUpdateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateProgressBar(cart.total_price);
      });
  }
  fetchAndUpdateCart();
}

async function getUpsellSectionItems() {
  const res = await fetch(`/?sections=${UPSELL_SECTION_HANDLE}`);
  const json = await res.json();
  const html = json[UPSELL_SECTION_HANDLE];

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const container = tempDiv.querySelector('#upsell-products-section');
  if (!container) {
    console.warn('No #upsell-products-section found');
    return [];
  }

  return Array.from(container.querySelectorAll('.cart_upsell_item'));
}

async function renderUpsellProducts() {
  const upsellContainer = document.querySelector('.cart-drawer__cross-sell-carousel');
  const cartUpsellItem = document.querySelector('.cart_upsell_items');
  if (!upsellContainer) return;

  cartUpsellItem.classList.add('loading');

  const cartData = await getCartData();

  if (!cartData.items || cartData.items.length === 0) {
    upsellContainer.innerHTML = '';
    cartUpsellItem.classList.add('hidden');
    cartUpsellItem.classList.remove('loading');
    return;
  }

  const cartProductIds = cartData.items.map(i => i.product_id);
  const cartVendors = cartData.items.map(i => i.vendor);
  const cartTypes = cartData.items.map(i => i.product_type);

  const allUpsellItems = await getUpsellSectionItems();
  
  let filteredItems = allUpsellItems.filter(item => {
  const productId = parseInt(item.dataset.productId, 10);
  const vendor = item.dataset.vendor;
  const type = item.dataset.productType;
  const collection = item.dataset.collection;

  // Exclude products already in cart
  if (cartProductIds.includes(productId)) return false;

  if (MATCH_BY === 'vendor' && vendor) return cartVendors.includes(vendor);
  if (MATCH_BY === 'type' && type) return cartTypes.includes(type);
  if (MATCH_BY === 'collection' && collection) return true; 

  return false;
});

  filteredItems = filteredItems.slice(0, UPSELL_LIMIT);

  // If no products match → hide
  if (filteredItems.length === 0) {
    upsellContainer.innerHTML = '';
    cartUpsellItem.classList.add('hidden');
    cartUpsellItem.classList.remove('loading');
    return;
  }

  // Show container (remove hidden)
  cartUpsellItem.classList.remove('hidden');
  upsellContainer.innerHTML = '';

  // Append filtered items
  filteredItems.forEach(item => {
    const productId = item.dataset.productId;
    const vendor = item.dataset.vendor;
    const type = item.dataset.productType;

    const title = item.querySelector('p')?.innerText || '';
    const imgSrc = item.querySelector('img')?.src || '';
    const productUrl = item.querySelector('a')?.href || '#';
    const variantId = item.querySelector('button')?.dataset.id || '';
    const priceHTML = item.querySelector('.price-list')?.outerHTML || '';

    upsellContainer.insertAdjacentHTML(
      'beforeend',
      `
      <div class="product-cross-sell cart_upsell_item"
           data-product-id="${productId}"
           data-vendor="${vendor}"
           data-product-type="${type}">
        <div class="horizonatal_controller">
          <div class="image_container_upsell">
            <a href="${productUrl}">
              <img src="${imgSrc}" alt="${title}" class="constrained-image">
            </a>
          </div>
          <div class="v-stack justify-items-start text_controller">
            <div class="v-stack gap-0.5">
              <a href="${productUrl}" class="h7">${title}</a>
              ${priceHTML}
            </div>
            <div class="add_to_cart_options">
              <button type="submit" data-id="${variantId}" class="add-to-cart">Add to cart</button>
            </div>
          </div>
        </div>
      </div>`
    );
  });

  initCarousel();

  setTimeout(function() {
    cartUpsellItem.classList.remove('loading');
  }, 1000);
  if (progressEl) {
     fetchAndUpdateCart();
    }
}

function initCarousel() {
  const slidesContainer = document.querySelector(".cart-drawer__cross-sell-carousel");
  const slides = slidesContainer?.querySelectorAll(".product-cross-sell");
  const prevButton = document.getElementById("slide-arrow-prev");
  const nextButton = document.getElementById("slide-arrow-next");

  if (!slidesContainer || !slides || slides.length === 0 || !prevButton || !nextButton) return;

  // Hide arrows if only 1 item
  if (slides.length <= 1) {
    prevButton.style.display = 'none';
    nextButton.style.display = 'none';
    return;
  } else {
    prevButton.style.display = '';
    nextButton.style.display = '';
  }

function updateButtons() {
  const slideWidth = slides[0].clientWidth;
  const scrollLeft = slidesContainer.scrollLeft;

  const currentIndex = Math.round(scrollLeft / slideWidth);
  const lastIndex = slides.length - 1;

  newPrev.disabled = currentIndex <= 0;
  newNext.disabled = currentIndex >= lastIndex;
}


  prevButton.replaceWith(prevButton.cloneNode(true));
  nextButton.replaceWith(nextButton.cloneNode(true));

  const newPrev = document.getElementById("slide-arrow-prev");
  const newNext = document.getElementById("slide-arrow-next");

  newNext.addEventListener("click", () => {
    slidesContainer.scrollBy({ left: slides[0].clientWidth, behavior: 'smooth' });
    setTimeout(updateButtons, 100);
  });

  newPrev.addEventListener("click", () => {
    slidesContainer.scrollBy({ left: -slides[0].clientWidth, behavior: 'smooth' });
    setTimeout(updateButtons, 100);
  });

  slidesContainer.addEventListener("scroll", updateButtons);

  updateButtons();

}


function triggerCartUpdate() {
  const quantitySelectors = document.querySelectorAll(
    'table.cart-items quantity-input.quantity '
  );
  if (!quantitySelectors.length) return;

  const lastIndex = quantitySelectors.length - 1;
  const quantityComponent = quantitySelectors[lastIndex];
  const input = quantityComponent.querySelector('input[type="number"]');
  const currentQty = parseInt(input.value, 10) || 0;

  quantityComponent.dispatchEvent(new CustomEvent('quantity:update', {
    detail: { quantity: currentQty, cartLine: lastIndex + 1 },
    bubbles: true
  }));
}


function addItemToCart(item_id, onComplete) {
  let formDataCustom = {
    'items': [{
      'id': item_id,
      'quantity': 1
    }],
    'sections': 'cart-drawer,cart-icon-bubble'
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formDataCustom)
  })
  .then(response => response.json())
  .then(data => {
    const cartDrawerElement = document.querySelector('cart-drawer');

    if (cartDrawerElement && typeof cartDrawerElement.renderContents === 'function') {
      cartDrawerElement.renderContents(data);
    } else {
        console.error('Cart drawer element or renderContents function not found.');
    }

    if (onComplete) onComplete();
  })
  .catch(err => {
    console.error('Add to cart failed:', err);
    if (onComplete) onComplete();
  });
}


// ONLY button click
document.addEventListener('click', function(event) {
    const button = event.target.closest('.add_to_cart_options button.add-to-cart');
    if (!button) return;

    event.preventDefault();
    const itemId = button.dataset.id;
    addItemToCart(itemId, () => {
        setTimeout(() => renderUpsellProducts(), 300);
    });
});


document.addEventListener('DOMContentLoaded', () => {
  const recommendations = document.querySelector('product-recommendations');

  if (!recommendations) {
    renderUpsellProducts();
    return;
  }

  const observer = new MutationObserver(() => {
    if (recommendations.querySelector('.cart_upsell_item')) {
      observer.disconnect();
      renderUpsellProducts();
    }
  });

  observer.observe(recommendations, {
    childList: true,
    subtree: true
  });
});

 document.addEventListener('DOMContentLoaded', renderUpsellProducts);
 document.addEventListener('cart:updated', renderUpsellProducts);
window.renderUpsellProducts = renderUpsellProducts;
window.initCarousel = initCarousel;